import React from 'react';
import { Typography } from "@material-ui/core";
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
  },
  icon: {
    margin: theme.spacing(1),
    color: "grey",
    width: "60px",
    height: "auto"
  }
}));


const Notfound: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <SentimentVeryDissatisfiedIcon className={classes.icon} />
      <Typography variant="h4" component="h1">このページは存在しません</Typography>
      <hr />
    </div>
  )
}

export default Notfound